import React from 'react';
import { LockOutlined } from '@ant-design/icons';
import talkSportLogo from '../../../../assets/images/Icons/talkSPORT_no_border_400.png';
import barclaysLogo from '../../assets/images/barclays-eagle-labs-logo_400.png';
import anglingTrustLogo from '../../../event_signup/asset/images/Angling-Trust-Logo-Flat 3.png';
import visaMark from '../../../user_bookings/assets/images/Visa.svg';
import mastercardMark from '../../../user_bookings/assets/images/Mastercard.svg';
import maestroMark from '../../../user_bookings/assets/images/Maestro.svg';
import applePayMark from '../../../user_bookings/assets/images/Apple_Pay_Mark_RGB_041619.svg';
import googlePayMark from '../../../user_bookings/assets/images/google-pay-mark_800.svg';
import '../../assets/css/footer_trust.css';

const PARTNERS = [
  {
    name: 'talkSPORT',
    href: 'https://fb.watch/fHSJUPIuhK/',
    logo: talkSportLogo,
    isDark: true,
  },
  {
    name: 'Barclays Eagle Labs',
    href: 'https://labs.uk.barclays/',
    logo: barclaysLogo,
  },
  {
    name: 'Angling Trust',
    href: 'https://anglingtrust.net/',
    logo: anglingTrustLogo,
  },
];

const PAYMENT_METHODS = [
  { name: 'Visa', mark: visaMark },
  { name: 'Mastercard', mark: mastercardMark },
  { name: 'Maestro', mark: maestroMark },
  { name: 'Apple Pay', mark: applePayMark },
  { name: 'Google Pay', mark: googlePayMark },
];

function FooterTrustRow() {
  return (
    <div className='sbf-trust flex-wrap' data-sbf-reveal>
      <div className='sbf-trust__group flex-wrap'>
        <span className='sbf-trust__label fs-13 gSemiBold'>
          As featured in / backed by
        </span>
        <ul className='sbf-trust__list flex-wrap'>
          {PARTNERS.map(({ name, href, logo, isDark }) => (
            <li key={name}>
              <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                className={`sbf-partner justify-center br8 ${
                  isDark ? 'sbf-partner--dark' : 'bg-white'
                }`}
              >
                <img src={logo} alt={name} />
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className='sbf-trust__group flex-wrap'>
        <span className='sbf-trust__label sbf-trust__label--secure gap-05r fs-13 gSemiBold'>
          <LockOutlined aria-hidden />
          Secure payments
        </span>
        <ul
          className='sbf-trust__list flex-wrap'
          aria-label='Accepted payment methods'
        >
          {PAYMENT_METHODS.map(({ name, mark }) => (
            <li key={name} className='sbf-payment'>
              <img src={mark} alt={name} title={name} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default FooterTrustRow;
